import { isEmpty, map, round } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CampaignTemplateStats } from '@dev/ee-api/ee-api-models';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { AbRecipientsType } from '@/store/campaignCreator/types';
import { useColorsAndSignatures } from './useColorsAndSignatures';
import { useCampaignScreensPathsChecker } from './useCampaignScreensPathsChecker';

export const useGetSummaryData = (): any[] => {
    const { t } = useTranslation();
    const { abRecipients, campaignSimpleStats } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const colorsAndSignature = useColorsAndSignatures();
    const summaryData = [];

    if (isDetailsScreen && !isEmpty(campaignSimpleStats)) {
        const recipientsTotalCount = campaignSimpleStats.Stats.Recipients;
        map(campaignSimpleStats.CampaignTemplatesSummary, (item: CampaignTemplateStats, index: number) => {
            const { IsWinner, Stats } = item;
            const templatePercent = round((Stats.Recipients * 100) / recipientsTotalCount, 2);

            summaryData.push({
                alphabetSignature: IsWinner ? t('winnerCaptalize') : colorsAndSignature[index].signature,
                uniqueRecipients: Stats.Recipients,
                uniqueRecipientsPercent: templatePercent,
                isWinner: IsWinner,
            });
        });

        return summaryData;
    }

    if (isEmpty(abRecipients)) {
        summaryData.push(
            {
                alphabetSignature: colorsAndSignature[0].signature,
                uniqueRecipients: 0,
                uniqueRecipientsPercent: 5,
                isWinner: false,
            },
            {
                alphabetSignature: colorsAndSignature[1].signature,
                uniqueRecipients: 0,
                uniqueRecipientsPercent: 5,
                isWinner: false,
            },
            {
                alphabetSignature: t('winnerCaptalize'),
                uniqueRecipients: 0,
                uniqueRecipientsPercent: 90,
                isWinner: true,
            }
        );
        return summaryData;
    }

    const mapedSummaryData = (item: AbRecipientsType, index: number) => {
        const { isWinner = false, uniqueRecipients, uniqueRecipientsPercent } = item;

        summaryData.push({
            alphabetSignature: isWinner ? t('winnerCaptalize') : colorsAndSignature[index].signature,
            uniqueRecipients,
            uniqueRecipientsPercent,
            isWinner,
        });
    };

    map(abRecipients, mapedSummaryData);

    return summaryData;
};
